import React from 'react';

function BackgroundSquares() {
  return (
    <div
      className="fixed inset-0 w-full h-full overflow-hidden z-0"
      style={{
        backgroundImage:
          'linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(61, 156, 251, 0.05) 50%, rgba(133, 16, 223, 0.106) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)',
      }}
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* All squares - single layout with vw units for consistent gaps */}
        {/* Hidden on very small screens for better performance */}
        <div className="hidden sm:block">
          {/* Top area */}
          <div className="absolute flex items-center justify-center left-[40.208vw] w-[19.638vw] h-[19.638vw] top-[-21.736vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[#8510df] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[50.486vw] w-[19.638vw] h-[19.638vw] top-[-11.389vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.67)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[40.181vw] w-[19.638vw] h-[19.638vw] top-[-0.860vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="relative w-[13.889vw] h-[13.889vw]">
                <svg
                  className="block size-full"
                  fill="none"
                  preserveAspectRatio="none"
                  viewBox="0 0 200 200"
                >
                  <path
                    d="M30 2H170C185.464 2 198 14.536 198 30V170C198 185.464 185.464 198 170 198H30C14.536 198 2 185.464 2 170V30C2 14.536 14.536 2 30 2Z"
                    opacity="0.05"
                    stroke="#8510DF"
                    strokeOpacity="0.67"
                    strokeWidth="4"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[29.861vw] w-[19.638vw] h-[19.638vw] top-[-11.389vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.67)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          {/* Left side */}
          <div className="absolute flex items-center justify-center left-[-0.139vw] w-[19.638vw] h-[19.638vw] top-[10.486vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.53)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[-10.486vw] w-[19.638vw] h-[19.638vw] top-[20.833vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.53)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[10.139vw] w-[19.638vw] h-[19.638vw] top-[20.833vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.53)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[-0.167vw] w-[19.638vw] h-[19.638vw] top-[31.361vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="relative w-[13.889vw] h-[13.889vw]">
                <svg
                  className="block size-full"
                  fill="none"
                  preserveAspectRatio="none"
                  viewBox="0 0 200 200"
                >
                  <path
                    d="M30 2H170C185.464 2 198 14.536 198 30V170C198 185.464 185.464 198 170 198H30C14.536 198 2 185.464 2 170V30C2 14.536 14.536 2 30 2Z"
                    opacity="0.05"
                    stroke="#8510DF"
                    strokeOpacity="0.53"
                    strokeWidth="4"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[6.111vw] w-[19.638vw] h-[19.638vw] top-[57.778vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.7)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[16.458vw] w-[19.638vw] h-[19.638vw] top-[47.431vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.7)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[26.736vw] w-[19.638vw] h-[19.638vw] top-[57.778vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.7)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[16.431vw] w-[19.638vw] h-[19.638vw] top-[68.306vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="relative w-[13.889vw] h-[13.889vw]">
                <svg
                  className="block size-full"
                  fill="none"
                  preserveAspectRatio="none"
                  viewBox="0 0 200 200"
                >
                  <path
                    d="M30 2H170C185.464 2 198 14.536 198 30V170C198 185.464 185.464 198 170 198H30C14.536 198 2 185.464 2 170V30C2 14.536 14.536 2 30 2Z"
                    opacity="0.05"
                    stroke="#8510DF"
                    strokeOpacity="0.7"
                    strokeWidth="4"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* Right side */}
          <div className="absolute flex items-center justify-center left-[81.806vw] w-[19.638vw] h-[19.638vw] top-[11.111vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.66)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[92.083vw] w-[19.638vw] h-[19.638vw] top-[21.458vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.66)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[71.458vw] w-[19.638vw] h-[19.638vw] top-[21.458vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.66)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[81.778vw] w-[19.638vw] h-[19.638vw] top-[31.987vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="relative w-[13.889vw] h-[13.889vw]">
                <svg
                  className="block size-full"
                  fill="none"
                  preserveAspectRatio="none"
                  viewBox="0 0 200 200"
                >
                  <path
                    d="M30 2H170C185.464 2 198 14.536 198 30V170C198 185.464 185.464 198 170 198H30C14.536 198 2 185.464 2 170V30C2 14.536 14.536 2 30 2Z"
                    opacity="0.05"
                    stroke="#8510DF"
                    strokeOpacity="0.66"
                    strokeWidth="4"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[59.583vw] w-[19.638vw] h-[19.638vw] top-[46.806vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.68)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[49.236vw] w-[19.638vw] h-[19.638vw] top-[57.153vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.68)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[69.861vw] w-[19.638vw] h-[19.638vw] top-[57.153vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="border-4 border-[rgba(133,16,223,0.68)] border-solid opacity-5 rounded-[2.083vw] w-[13.889vw] h-[13.889vw]" />
            </div>
          </div>

          <div className="absolute flex items-center justify-center left-[59.556vw] w-[19.638vw] h-[19.638vw] top-[67.681vw]">
            <div className="flex-none rotate-[43.892deg]">
              <div className="relative w-[13.889vw] h-[13.889vw]">
                <svg
                  className="block size-full"
                  fill="none"
                  preserveAspectRatio="none"
                  viewBox="0 0 200 200"
                >
                  <path
                    d="M30 2H170C185.464 2 198 14.536 198 30V170C198 185.464 185.464 198 170 198H30C14.536 198 2 185.464 2 170V30C2 14.536 14.536 2 30 2Z"
                    opacity="0.05"
                    stroke="#8510DF"
                    strokeOpacity="0.68"
                    strokeWidth="4"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BackgroundSquares;
